module.exports = __webpack_public_path__ + "static/media/bear.4eaeeda7.png";